<template>
    <div class="popup-container">
        <div class="popup">
            <div class="popup__title">Confirmation</div>
            <p>You are about to publish your itinerary. Do you wish to continue?</p>

            <div class="popup__buttons">
                <button class="white-btn"
                    v-on:click="closePopup">Cancel</button>
                <button class="main-btn confirm-btn"
                    v-on:click="closePopup">Publish</button>
            </div>
        </div>
    </div>
</template>

<script>
    import Eventbus from '../modules/eventbus'

    export default {
        name: 'PublishPopup',
        methods: {
            closePopup: function() {
                Eventbus.$emit('closePublishPopup')
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../styles/confirmationPopup";
</style>
